// extracted by mini-css-extract-plugin
module.exports = {"btn":"GeneratePairingCode_btn__1xwgK"};